import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDYj2SWTrRpvXRDImREYsCJxt4U-PrhUoM",
    authDomain: "discord-e37f8.firebaseapp.com",
    databaseURL: "https://discord-e37f8.firebaseio.com",
    projectId: "discord-e37f8",
    storageBucket: "discord-e37f8.appspot.com",
    messagingSenderId: "799565946341",
    appId: "1:799565946341:web:fe1056336e943e42bae30c",
    measurementId: "G-Y8X1HZRVHY"
  };
  const firebaseApp=firebase.initializeApp(firebaseConfig);
  const db=firebaseApp.firestore();
  const auth=firebase.auth();
  const provider=new firebase.auth.GoogleAuthProvider();

  export{auth,provider};
  export default db;
  